<template>
  <div>
    <admin-wrapper
      title-translation-path="admin.activityLog.moduleTitle"
      :module-enabler="moduleEnabler"
      :inputs="inputs"
      :has-buttons="false"
      :is-form-fetched="true"
    >
      <template #[`table.input`]>
        <activity-log-table></activity-log-table>
      </template>
    </admin-wrapper>
  </div>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import ActivityLogTable from '@/components/ActivityLogTable';
export default {
  name: 'ActivityLogSettings',
  components: {
    ActivityLogTable,
    AdminWrapper,
  },
  computed: {
    inputs() {
      return [
        {
          name: 'table',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'activity_log_module_enabled',
        translationPath: 'admin.activityLog.moduleTitle',
        subtitle: this.$i18n.t('admin.moduleEnabler', {
          suffix: this.$i18n.t('admin.activityLog.moduleTitle'),
        }),
      };
    },
  },
};
</script>
